export type IBppFormSixthSectionInterface = {
    MarketValue?: string,
    IsMarketValueCertified? : boolean,
}


export const SixthSectionInitialState = {
    MarketValue: undefined,
    IsMarketValueCertified: undefined
}